// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__319YI","options":"AnswerScale_options__1aC_o","selected":"AnswerScale_selected__2s2pC"};